export default __webpack_public_path__ + "static/2178-658d235330d3e107eed21e42d86e44e8.gif";